import { DatePicker } from "antd"
import { FetchAdjustmentsData, FetchHistoricAdjustmentsData } from "../../Repository/AdjustmentsRepository";
import { StringValidations } from "../../Utils/Utils";
import dayjs from "dayjs";
import "../../GlobalCss/SPF/AdjustmentsComponents.css"

const GetHistoricAdjustments = ({frequency, setLoadGrid, setDataSource, dateValue, setDateValue}) => {
    const handleDateChange =(date)=>{
        setDateValue(date);
        if(StringValidations(date)){
            FetchHistoricAdjustmentsData(date, frequency, setLoadGrid, setDataSource);
        }
        else{
            FetchAdjustmentsData(frequency, setLoadGrid, setDataSource);
        }
    }
    return (
        <DatePicker
            className="adjustments-paydate"
            placeholder="Pay Date"
            format="MM/DD/YYYY"
            onChange={(date, dateString) => handleDateChange(dateString)}
            value={StringValidations(dateValue)?dayjs(dateValue, "MM/DD/YYYY"):null}
        />
    )
}

export default GetHistoricAdjustments;